export const isStaging =
  import.meta.env.MODE === 'development' ||
  window.location.hostname.includes('staging.') ||
  window.location.hostname.includes('localhost')

export const isPreProd = window.location.hostname.includes('preprod.')
